
import { computed, defineComponent, PropType } from 'vue';
import {
  Button, Dropdown, Menu, Spin,
} from 'ant-design-vue';
import { CaretRightOutlined } from '@ant-design/icons-vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { RoleDataI } from '@/views/Teacher/customCaseEdit/scenarioConstruction/js/interface';
import '@/assets/icons/back2.svg';
import asynButtonVue from '@/components/asynButton.vue';

const component = defineComponent({
  name: 'scene-edit-box',
  components: {
    SvgIcon,
    CaretRightOutlined,
    aButton: asynButtonVue,
    aDropdown: Dropdown,
    aMenu: Menu,
    aMenuItem: Menu.Item,
    aSpin: Spin,
  },
  props: {
    editItem: {
      type: Object as PropType<RoleDataI>,
      require: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const btnItem = computed(() => ({
      text: props.editItem?.status ? '已启用' : '已禁用',
      btnStyle: props.editItem?.status,
    }));

    const back = () => {
      context.emit('back');
    };

    const change = (status: { key: string }) => {
      context.emit('changeDepartmentStatus', status.key === '1');
    };

    return {
      props,
      btnItem,
      back,
      change,
    };
  },
});

export default component;
